import { isArray } from 'util';
import { NonProductiveManufacturingOrder } from '../non-productive-manufacturing-order';

export class NonProductiveManufacturingOrderBuilder {
  static fromJson(json) {
    return (json)
      ? new NonProductiveManufacturingOrder(
        json.hash,
        json.code,
        json.projectNumber,
        json.description,
        json.categoryHash,
        json.categoryName
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(NonProductiveManufacturingOrderBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/non-productive-manufacturing-order.builder.ts